/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ regio: NonNullable<unknown> }} Planning_Vakanties_RegioInputs */

const nl_planning_vakanties_regio = /** @type {(inputs: Planning_Vakanties_RegioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regio ${i?.regio}`)
};

/**

* @param {Planning_Vakanties_RegioInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_regio = /** @type {((inputs: Planning_Vakanties_RegioInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_RegioInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_regio(inputs)
});
export { planning_vakanties_regio as "planning.vakanties.regio" }